module.exports = __webpack_public_path__ + "img/footer-payments.9829bf8.webp";